import type { IParamGroupTable, IUpdateData, getCountParam } from '../../API/groupSchedule'
import type {
  ICountDiagram,
  IGroupLine,
  IGroupLineEdit,
  IGroupLineEdit2
} from '../../interfaces/index'
import type { DaysDiagram } from '../../models/enum'

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import GroupSchedule from '../../API/groupSchedule'

export interface IGroupScheduleSlice {
  data: IGroupLine[]
  count: number
  editData: IGroupLineEdit
  isLoading: boolean
  isLoadingEditData: boolean
  countDiagram: ICountDiagram
}
export interface IUpdateRowRedux extends IUpdateData {
  currentDay: DaysDiagram | undefined
  currentData: IGroupLine[]
}
export interface ICoverageReturn {
  excludeCategory: string[]
  includeCategory: string[]
}
// new
export interface IUpdateRowNew {
  data: IGroupLineEdit2
  groupNumber: string
  currentDay: DaysDiagram | undefined
  coverage: string[]
  currentData: IGroupLine[]
}
const initialState: IGroupScheduleSlice = {
  data: [],
  count: 0,
  editData: {
    RXCompany: '',
    key: '',
    groupNumber: '',
    groupName: '',
    checkRunDay: '',
    funding: '',
    notes: '',
    renewalDate: '',
    aeAm: '',
    runOutDate: '',
    groupContact: '',
    salesExc: '',
    availableCoverageCategories: '',
    excludedCoverageCategories: null,
    rff: false,
    release: false
  },
  isLoadingEditData: false,
  isLoading: false,
  countDiagram: {}
}
export const fetchGroupScheduleTable = createAsyncThunk(
  'groupSchedule/fetchTable',
  async (param: IParamGroupTable) => {
    const response = await GroupSchedule.getGroupSheduleTable(param).then(response => response)
    const newData: IGroupLine[] = response.data.map(item => {
      return { ...item, key: `${item.groupNumber}${item.groupName}` }
    })
    response.data = newData
    return response
  }
)
export const fetchCountByDiagram = createAsyncThunk(
  'groupSchedule/fetchCountByDiagram',
  async (obj: getCountParam, { rejectWithValue: _rejectWithValue }) => {
    const response = await GroupSchedule.getCount(obj).then(response => response)
    return response
  }
)

export const fetchEditData = createAsyncThunk(
  'groupSchedule/fecthEditData',
  async (groupNumber: string, { rejectWithValue: _rejectWithValue }) => {
    const response = await GroupSchedule.getEditInformation({ groupNumber }).then(
      response => response
    )
    return response
  }
)

export const updateRow = createAsyncThunk(
  'groupSchedule/updateRow',
  async (params: IUpdateRowNew) => {
    if (params.currentDay === undefined) {
      return params.currentData
    } else {
      let data = params.currentData
      const editData = params.data
      if (params.data.checkRunDay === 'HOLD' || params.data.checkRunDay === 'NEW BUSINESS') {
        data = data.filter(item => item.groupNumber !== 'HOLD' || item.groupName !== 'NEW BUSINESS')
        data = data.map(item =>
          params.groupNumber === item.groupNumber
            ? {
                ...item,
                checkRunDay: editData.checkRunDay,
                notes: editData.notes,
                runOutDate: editData.runOutDate,
                renewalDate: editData.renewalDate,
                funding: editData.funding,
                excludedCoverageCategories: params.coverage.join(',')
              }
            : item
        )
        return [...data]
      } else {
        const days = params.data.checkRunDay.split(',').includes(params.currentDay.toUpperCase())
          ? ''
          : params.groupNumber
        data = data.filter(item => item.groupNumber !== days)
        data = data.map(item =>
          params.groupNumber === item.groupNumber
            ? {
                ...item,
                checkRunDay: editData.checkRunDay,
                notes: editData.notes,
                runOutDate: editData.runOutDate,
                renewalDate: editData.renewalDate,
                funding: editData.funding,
                excludedCoverageCategories: params.coverage.join(',')
              }
            : item
        )
        return [...data]
      }
    }
  }
)

export const groupScheduleSlice = createSlice({
  name: 'groupSchedule',
  initialState,
  reducers: {
    clearData: state => {
      state.data = []
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchCountByDiagram.fulfilled, (state, action) => {
      state.countDiagram = action.payload
    })
    builder.addCase(fetchGroupScheduleTable.fulfilled, (state, action) => {
      state.data = action.payload.data
      state.count = Number(action.payload.count)
      state.isLoading = false
    })
    builder.addCase(fetchGroupScheduleTable.pending, state => {
      state.isLoading = true
    })
    builder.addCase(fetchEditData.fulfilled, (state, action) => {
      state.editData = action.payload.data
      state.isLoadingEditData = false
    })
    builder.addCase(fetchEditData.pending, state => {
      state.isLoadingEditData = true
    })
    builder.addCase(updateRow.fulfilled, (state, action) => {
      state.data = [...action.payload]
    })
  }
})

export const { clearData } = groupScheduleSlice.actions
export default groupScheduleSlice.reducer
